//action imports
import * as allActions from "../../actions/actions.constants";

const initialState = {
  isLoading: false,
  isLoaded: false,
  ManagemebersData: [],
};
export default function ModeratorReducer(state = initialState, action) {
  switch (action.type) {
    case allActions.MANAGE_MEMBERS_LOADING:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        ManagemebersData: [],
      };
    case allActions.RECIEVE_MANAGE_MEMBERS_DATA:
      return {
        ...state,
        ManagemebersData: action.payload,
        isLoading: false,
        isLoaded: true,
      };

    default:
      return state;
  }
}
